var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 119,
    height: 63,
    viewBox: "0 0 119 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.82 36.47L18.94 38.26C17.28 35.64 15.04 34.42 12.48 34.42H10.56C6.53 34.42 3.39 37.43 3.39 41.27V62.58H0V30.84H3.39V33.66C4.22 32.64 7.29 31.04 10.56 31.04H12.48C16.13 31.04 19.58 32.9 21.82 36.48V36.47Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70.7874 46.13V48.5H41.3474C41.5184 50.4939 42.2195 52.4059 43.3783 54.0376C44.537 55.6693 46.1111 56.9614 47.9374 57.78C53.3774 60.34 60.2873 59.32 65.8573 54.64L68.0374 57.27C64.2337 60.5902 59.3851 62.4695 54.3374 62.58C51.6417 62.5848 48.9782 61.9941 46.5374 60.85C43.864 59.6168 41.6126 57.6242 40.0638 55.1205C38.515 52.6168 37.7372 49.7126 37.8273 46.77C37.8691 42.421 39.6159 38.2621 42.6922 35.1877C45.7684 32.1134 49.9284 30.3691 54.2774 30.33C63.2774 30.33 70.7273 37.81 70.7273 46.13H70.7874ZM67.2673 45.13C66.7573 38.99 61.2673 33.74 54.2673 33.74C47.2673 33.74 41.7874 38.99 41.3374 45.13H67.2673Z",
    fill: "#231F20"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRed);
export default __webpack_public_path__ + "static/media/RED.fb39aca34dfd68343d6247c1146ca231.svg";
export { ForwardRef as ReactComponent };